import { useFormikContext } from 'formik';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  header: {
    id: 'account.super-profiles.update-confirmation-modal.header',
    defaultMessage: 'Confirm updating SuperProfile',
  },
  firstParagraph: {
    id: 'account.super-profiles.update-confirmation-modal.first-paragraph',
    defaultMessage: 'Please make sure that you actually want to change the existing Job Profile.',
  },
  secondParagraph: {
    id: 'account.super-profiles.update-confirmation-modal.second-paragraph',
    defaultMessage: 'If you do, all SuperMatches based on it will also be deleted.',
  },
  cancel: { id: 'actions.cancel', defaultMessage: 'Cancel' },
  submit: { id: 'actions.submit', defaultMessage: 'Submit' },
});

const UpdateSuperProfileConfirmationDialog = ({ visible, hide }) => {
  const { formatMessage } = useIntl();
  const { handleSubmit } = useFormikContext();

  const header = <div className="dashboard-panel-header">{formatMessage(messages.header)}</div>;

  return (
    <Dialog visible={visible} onHide={hide} header={header} modal>
      <p>{formatMessage(messages.firstParagraph)}</p>
      <p>{formatMessage(messages.secondParagraph)}</p>
      <div className="mt20 flex-center">
        <Button type="button" className="p-button-secondary" label={formatMessage(messages.cancel)} onClick={hide} />
        <Button
          type="button"
          className="p-button-primary"
          label={formatMessage(messages.submit)}
          onClick={handleSubmit}
        />
      </div>
    </Dialog>
  );
};

export default UpdateSuperProfileConfirmationDialog;
